export default {
  home: '/',
  contacts: '/contacts',
  logins: '/login',
  register: '/register',
};
